import { useFormContext } from "react-hook-form";
import { DataRecipesCategory } from "../../../../redux/@types/recipesCategories";
import { useSelector } from "react-redux";
import { Button, Col, Typography, message } from "antd";

import {
  selectRecipesCategoryForUpdate,
  selectIsUpdateRecipesCategory,
  selectModalRecipesCategories,
  RecipesCategoriesChangeModalState,
} from "../../../../redux";
import { InputText, InputNumber, InputSelect } from "../inputs";
import Upload from "../inputs/Upload";
import { PATH_S3_BUCKET } from "../../../utils/constants";
import { useRecipesCategories } from "../../../../modules/recipesCategories/hook";
import { WrapperModalRecipesCategories } from "../../../../modules/recipesCategories/ui/styled";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";

const { Title } = Typography;

export const ModalRecipesCategories = () => {
  const modalRecipesCategories = useSelector(selectModalRecipesCategories);
  const isUpdateRecipesCategory = useSelector(selectIsUpdateRecipesCategory);
  const updateRecipesCategory = useSelector(selectRecipesCategoryForUpdate);

  const dispatch = useAppDispatch();

  const { isLoading, onSubmitCreateOrUpdate } = useRecipesCategories();

  const { control, handleSubmit, setValue, watch, reset } =
    useFormContext<DataRecipesCategory>();
  const pathCover = watch("path_cover");

  return (
    <WrapperModalRecipesCategories
      title={
        isUpdateRecipesCategory
          ? `Actualizando categoría: '${updateRecipesCategory?.id!}'`
          : `Creando categoría de receta`
      }
      open={modalRecipesCategories}
      width={"420px"}
      destroyOnClose
      onClose={() => {
        reset({});
        dispatch(RecipesCategoriesChangeModalState(false));
      }}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText
          placeHolder="Nombre de la categoría"
          name="name"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Imagen de portada:
        </Title>
        {pathCover ? (
          <img
            src={`${PATH_S3_BUCKET}/${pathCover}`}
            alt="path_cover"
            style={{
              marginBottom: "7px",
              width: "100%",
              height: "100%",
              maxWidth: "250px",
              maxHeight: "250px",
            }}
          />
        ) : null}
        <Upload
          filePath="recipes-categories"
          onUploadedFile={(files) => {
            const file = files[0] || files;
            setValue("path_cover", file.fileKey);
            message.success("Imagen subida correctamente");
          }}
          value={pathCover || undefined}
          placeHolder="Cargar imagen de portada"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Prioridad:
        </Title>
        <InputNumber
          placeHolder="Prioridad"
          name="priority"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>
      <Button
        style={{ width: "100%", marginTop: 10 }}
        type="primary"
        shape="round"
        size="large"
        onClick={handleSubmit(onSubmitCreateOrUpdate)}
        loading={isLoading}
      >
        {isUpdateRecipesCategory ? "Actualizar categoría" : "Crear categoría"}
      </Button>
    </WrapperModalRecipesCategories>
  );
};
